module.exports = __webpack_public_path__ + "static/media/xml.95965c22.svg";